/*
 * Wunschmoment Offer A/B Test (offer_2026)
 * Fullscreen Email-Popup + Sticky-Open-Button. Nur aktiv in der offer-Variante.
 *
 * localStorage:
 *   wm_offer_popup_seen        – Popup wurde einmal gesehen/geschlossen (kein Auto-Open mehr)
 *   wm_offer_sticky_dismissed  – Sticky-Button per X dauerhaft ausgeblendet
 *   wm_offer_signed_up         – Email erfolgreich abgeschickt
 */
(function () {
  'use strict';

  /* Build-Marker zur Cache-Diagnose: in der Konsole `window.__wmOfferPopupBuild` abfragen.
     Fehlt der Wert oder ist er < 3 → alte (gecachte) JS läuft noch. */
  window.__wmOfferPopupBuild = 29;

  /* Popup/Sticky in ZWEI Tests aktiv (identisches UI):
       • offer_2026 (eingefroren): data-offer="offer" + data-offer-popup="1"
       • offer_popup_2026 (neu):   data-shipping="included" + data-shipping-popup="1"
     Sonst hier aussteigen. */
  var wmDE = document.documentElement;
  var wmIsOfferPopup = wmDE.getAttribute('data-offer') === 'offer' && wmDE.getAttribute('data-offer-popup') === '1';
  var wmIsShipPopup = wmDE.getAttribute('data-shipping') === 'included' && wmDE.getAttribute('data-shipping-popup') === '1';
  if (!wmIsOfferPopup && !wmIsShipPopup) return;

  var AUTO_OPEN_DELAY = 5000;
  /* Sticky-Button erst nach diesem Delay nach Reload einblenden (mit Slide-in) */
  var STICKY_DELAY = 5000;

  /* true = Testphase (Sticky bleibt nach Signup sichtbar, Flow beliebig wiederholbar).
     false = Normalverhalten: Sticky verschwindet dauerhaft nach X-Klick ODER Email-Signup. */
  var WM_POPUP_TEST = false;

  /* Eigener Backend-Endpoint (wie Klaviyo): umgeht Shopifys /contact-Captcha komplett. */
  var API_BASE = 'https://wunschmoment-backend.vercel.app';
  var NEWSLETTER_ENDPOINT = API_BASE + '/api/newsletter';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function track(event) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('wunschmoment:' + event, {
          ab_tests: window.__wmTests ? JSON.stringify(window.__wmTests) : null,
          timestamp: new Date().toISOString()
        });
      }
    } catch (e) {}
    // Zusätzlich ans eigene Backend (First-Party Funnel, GA4-unabhängig)
    if (typeof window.wmTrackEvent === 'function') window.wmTrackEvent(event);
  }

  function init() {
    var popup = document.getElementById('wm-offer-popup');
    var sticky = document.getElementById('wm-offer-sticky');
    /* Nur popup ist Pflicht — der Form-Handler MUSS greifen, sonst lädt das native Submit die Seite neu.
       Sticky ist optional (unten null-sicher behandelt). */
    if (!popup) return;

    /* Form robust über die Klasse holen (Shopify übernimmt die id bei {% form 'customer' %}
       nicht zuverlässig → sonst greift der Handler nicht und das native Submit lädt die Seite neu). */
    var form = popup.querySelector('.wm-offer-popup__form') || document.getElementById('wm-offer-popup-form');
    var formWrap = popup.querySelector('[data-wm-offer-form-wrap]');
    var success = popup.querySelector('[data-wm-offer-success]');
    var headline = popup.querySelector('[data-wm-offer-headline]');
    var startBtn = popup.querySelector('[data-wm-offer-start]');
    var image = popup.querySelector('.wm-offer-popup__image');

    function signedUp() { return lsGet('wm_offer_signed_up') === '1'; }
    function stickyDismissed() { return lsGet('wm_offer_sticky_dismissed') === '1'; }

    /* Signup-Flag als HTML-Attribut → das Personalizer-Badge zeigt sich nur für Nutzer,
       die im Popup ihre Email eingegeben haben (CSS-gated auf [data-wm-offer-signup="1"]). */
    if (signedUp()) document.documentElement.setAttribute('data-wm-offer-signup', '1');

    /* ── Cookie-Banner-Gate ── Popup UND beide Sticky-Buttons erst nach dem Banner starten.
       Shopify injiziert den Banner oft NACH unserem Script → gepollt (erkennt auch spätes Erscheinen).
       "resolved" = Banner war da und ist wieder weg, ODER es erschien keiner (Consent schon erteilt). */
    function cookieBannerVisible() {
      var b = document.querySelector('.shopify-pc__banner__dialog') || document.querySelector('.shopify-pc__banner');
      if (!b) return false;
      var cs = window.getComputedStyle(b);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
      var rect = b.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }
    var cookieResolved = false;
    var cookieCbs = [];
    var cookieSeen = false;
    var cookieStart = Date.now();
    function pollCookie() {
      if (cookieResolved) return;
      if (cookieBannerVisible()) { cookieSeen = true; setTimeout(pollCookie, 300); return; }
      if (cookieSeen || Date.now() - cookieStart >= 2500) {
        cookieResolved = true;
        while (cookieCbs.length) cookieCbs.shift()();
        return;
      }
      setTimeout(pollCookie, 300);
    }
    function whenCookieResolved(cb) {
      if (cookieResolved) { cb(); return; }
      cookieCbs.push(cb);
    }
    pollCookie();

    /* ── Offer-Mail-Deeplink (?wm_start=1) ── Nutzer kommt aus der Offer-Mail:
       Personalizer SOFORT öffnen, sobald er bereit ist (NICHT hinter dem Cookie-Gate — das
       hätte 2,5s Grace-Delay). Der Klick ist user-initiiert, darf also direkt aufgehen.
       Das "Angebot aktiviert"-Badge kommt über data-wm-offer-signup (im <head> gesetzt). */
    function getParam(name) {
      try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; }
    }
    if (getParam('wm_start') === '1') {
      /* URL bereinigen → ein Reload öffnet den Personalizer nicht erneut (localStorage hält den Zustand). */
      try {
        var wmU = new URL(location.href);
        wmU.searchParams.delete('wm_start');
        history.replaceState(null, '', wmU.pathname + wmU.search + wmU.hash);
      } catch (e) {}
      var wmStartTries = 0;
      (function openWhenReady() {
        if (typeof window.wmOpenPersonalizer === 'function') { window.wmOpenPersonalizer(); return; }
        if (wmStartTries++ < 100) setTimeout(openWhenReady, 100); /* bis ~10s auf Personalizer warten */
      })();
    }

    /* Sticky-Email-Button gilt als "erledigt", wenn per X ausgeblendet ODER Email gesichert.
       Dann darf der Buy-Button wieder sticky werden (CSS: [data-wm-cta-sticky="1"]).
       Verzögert (STICKY_DELAY) → gleicher 5s-Slide-up-Rhythmus wie der Sticky-Button. */
    function markCtaSticky() {
      /* Slide-up nur, wenn der Buy-Button gerade NICHT sichtbar ist (er slidet dann echt rein).
         Ist er schon sichtbar, bleibt er an Ort und Stelle → keine (sinnlose) Animation. */
      var btn = document.querySelector('.wm-buy-button');
      if (btn) {
        var r = btn.getBoundingClientRect();
        var visible = r.bottom > 0 && r.top < window.innerHeight;
        if (!visible) document.documentElement.setAttribute('data-wm-cta-animate', '1');
      }
      document.documentElement.setAttribute('data-wm-cta-sticky', '1');
    }
    function markCtaStickyDelayed() { setTimeout(markCtaSticky, STICKY_DELAY); }
    /* Beim Laden: Buy-Button erst nach dem Cookie-Banner (+5s) sticky machen */
    if (stickyDismissed() || signedUp()) whenCookieResolved(markCtaStickyDelayed);

    function showSticky() {
      if (!sticky || stickyDismissed() || (signedUp() && !WM_POPUP_TEST)) return;
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    }
    function hideSticky() {
      if (!sticky) return;
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }

    function showSuccess() {
      if (headline) headline.style.display = 'none';
      if (formWrap) formWrap.style.display = 'none';
      if (image) image.style.display = 'none';
      if (success) success.hidden = false;
    }
    function resetToForm() {
      if (headline) headline.style.display = '';
      if (formWrap) formWrap.style.display = '';
      if (image) image.style.display = '';
      if (success) success.hidden = true;
      var sb = form && form.querySelector('.wm-offer-popup__submit');
      if (sb) { sb.disabled = false; sb.textContent = 'Jetzt sichern'; }
    }

    function openPopup() {
      resetToForm();
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      track('offer_popup_view');
    }
    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      lsSet('wm_offer_popup_seen', '1');
      /* Sticky erst nach 5s wieder einblenden (mit Slide-in), nicht sofort beim Schließen */
      setTimeout(showSticky, STICKY_DELAY);
    }

    /* ── Close-Trigger (X + Backdrop) ── */
    popup.querySelectorAll('[data-wm-offer-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    /* ── Sticky-Button: X blendet dauerhaft aus, jeder andere Klick öffnet das Popup ── */
    if (sticky) {
      sticky.addEventListener('click', function (e) {
        if (e.target.closest('[data-wm-offer-sticky-dismiss]')) {
          e.stopPropagation();
          lsSet('wm_offer_sticky_dismissed', '1');
          track('offer_sticky_dismiss');
          hideSticky();
          markCtaStickyDelayed();
          return;
        }
        track('offer_sticky_click');
        openPopup();
      });
    }

    /* ── Email-Signup per AJAX an unser Backend (/api/newsletter) — kein Shopify /contact,
       daher kein Captcha/Reload. Double-Opt-in wird server-seitig gesetzt. ── */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('[data-wm-offer-email]');
        var hpInput = form.querySelector('[data-wm-offer-hp]');
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) { if (emailInput) emailInput.focus(); return; }
        var submitBtn = form.querySelector('.wm-offer-popup__submit');
        if (submitBtn && submitBtn.disabled) return; /* Doppel-Submit verhindern */
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }
        fetch(NEWSLETTER_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, hp: hpInput ? hpInput.value : '' })
        }).then(function (res) {
          return res.json().then(
            function (data) { return { ok: res.ok, data: data }; },
            function () { return { ok: res.ok, data: {} }; }
          );
        }).then(function (r) {
          if (!r.ok || !r.data || r.data.ok !== true) {
            throw new Error((r.data && r.data.error) || 'request_failed');
          }
          lsSet('wm_offer_signed_up', '1');
          lsSet('wm_offer_popup_seen', '1');
          document.documentElement.setAttribute('data-wm-offer-signup', '1');
          markCtaStickyDelayed();
          track('offer_email_signup');
          showSuccess();
          if (!WM_POPUP_TEST) hideSticky();
        }).catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Jetzt sichern'; }
        });
      });
    }

    /* ── Success-CTA: Popup schließen + Personalizer öffnen (nahtlos in den Gestalten-Flow) ── */
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        closePopup();
        if (typeof window.wmOpenPersonalizer === 'function') window.wmOpenPersonalizer();
      });
    }

    /* ── Auto-Open / Sticky-Initialzustand ── */
    /* In der Testphase NICHT früh aussteigen, damit der Sticky-Button nach Signup sichtbar bleibt. */
    if (signedUp() && !WM_POPUP_TEST) return;

    if (lsGet('wm_offer_popup_seen') === '1') {
      /* Nach dem Cookie-Banner + 5s: Sticky-Email-Button einblenden (nicht sofort, nicht ueber dem Banner) */
      whenCookieResolved(function () { setTimeout(showSticky, STICKY_DELAY); });
    } else {
      /* Nach dem Cookie-Banner + 5s: Popup oeffnen */
      whenCookieResolved(function () {
        setTimeout(function () {
          if (!popup.classList.contains('is-open') && lsGet('wm_offer_popup_seen') !== '1') {
            openPopup();
          }
        }, AUTO_OPEN_DELAY);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
